import React, { useEffect, useRef, useState } from "react";

const SCANNER_ID = "fh-qr-scanner-region";

export default function QrScanner({ onScan, onError, paused = false }) {
  const scannerRef = useRef(null);
  const onScanRef = useRef(onScan);
  const onErrorRef = useRef(onError);
  const [status, setStatus] = useState("init");

  useEffect(() => {
    onScanRef.current = onScan;
  }, [onScan]);

  useEffect(() => {
    onErrorRef.current = onError;
  }, [onError]);

  useEffect(() => {
    let stopped = false;
    let scanner = null;

    (async () => {
      try {
        const { Html5Qrcode } = await import("html5-qrcode");
        if (stopped) return;
        scanner = new Html5Qrcode(SCANNER_ID, { verbose: false });
        scannerRef.current = scanner;
        await scanner.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 240, height: 240 }, aspectRatio: 1.0 },
          (decodedText) => {
            onScanRef.current?.(decodedText);
          },
          () => {
            // Per-frame "no QR found" – ignorieren
          },
        );
        setStatus("running");
      } catch (err) {
        setStatus("error");
        onErrorRef.current?.(err);
      }
    })();

    return () => {
      stopped = true;
      if (scanner) {
        // stop() wirft SYNCHRON, wenn der Scanner nie lief (z.B. Kamera verweigert) —
        // ohne try/catch crasht der Tab-Wechsel die ganze App (weißer Bildschirm)
        try {
          if (scanner.isScanning) {
            scanner.stop().then(() => scanner.clear()).catch(() => {});
          } else {
            scanner.clear();
          }
        } catch {
          /* Scanner war nicht aktiv — nichts zu stoppen */
        }
      }
    };
  }, []);

  useEffect(() => {
    const scanner = scannerRef.current;
    if (!scanner) return;
    if (paused && status === "running") {
      scanner.pause(true);
    } else if (!paused && status === "running") {
      try {
        scanner.resume();
      } catch {
        /* not paused */
      }
    }
  }, [paused, status]);

  return (
    <div className="relative">
      <div id={SCANNER_ID} className="rounded-lg overflow-hidden bg-fh-black aspect-square w-full" />
      {status === "init" && (
        <div className="absolute inset-0 flex items-center justify-center text-white text-sm">
          Kamera wird gestartet…
        </div>
      )}
      {status === "error" && (
        <div className="absolute inset-0 flex items-center justify-center bg-fh-black text-white text-sm p-4 text-center">
          Kamera konnte nicht gestartet werden.<br />
          <span className="text-xs text-white/70 mt-1">Berechtigung prüfen oder Item-Code manuell eingeben.</span>
        </div>
      )}
    </div>
  );
}
